<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Ruta {{ form.nombre }}</h3>
        <label>
          <div v-show="estado === 'I'" class="noti-danger">
            <strong>INACTIVA</strong>
          </div>
          <div v-show="estado === 'A'" class="noti-success">
            <strong>ACTIVA</strong>
          </div>
          <div v-show="estado === 'N'" class="noti-secondary">
            <strong>NUEVA</strong>
          </div>
        </label>
      </div>
      <div class="layout__controls">
        <div class="form-inline">
          <button
            v-show="
              puede_consultar_rutas || puede_editar_ruta || puede_eliminar_ruta
            "
            class="btn-info btn--bigger"
            type="button"
            @click="consultar"
          >
            <i class="fa fa-search"></i><span>Consultar</span>
          </button>
        </div>
      </div>
    </div>
    <div class="layout__main">
      <div class="layout__main-form">
        <div class="card">
          <div class="card__title">
            <h5>Información de la ruta</h5>
          </div>
          <div class="card__content">
            <div class="row">
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field
                    :readonly="estado !== 'N'"
                    placeholder="Escriba un código..."
                    id="codigo"
                    name="codigo"
                    v-model="form.codigo"
                  >
                    <span>Código*</span>
                    <span
                      v-if="errores.codigo"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.codigo[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select
                      placeholder="Seleccione..."
                      :options="bodegas"
                      id="bodega"
                      name="bodega"
                      @input="inputBodega"
                      v-model="selectedBodega"
                      label="descripcion"
                    ></v-select>
                    <label for="bodega">Sucursal*</label>
                    <span
                      v-if="errores.bodega_id"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.bodega_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <input-field
                    placeholder="Escriba un nombre..."
                    id="nombre"
                    name="nombre"
                    v-model="form.nombre"
                  >
                    <span>Nombre*</span>
                    <span
                      v-if="errores.nombre"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.nombre[0] }}</strong>
                    </span>
                  </input-field>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="form-field">
                  <textarea-field
                    placeholder="Escriba una o varias direcciones..."
                    id="direcciones"
                    v-model="form.direcciones"
                  >
                    <span>Direcciones*</span>
                    <span
                      v-if="errores.direcciones"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.direcciones[0] }}</strong>
                    </span>
                  </textarea-field>
                </div>
              </div>
              <!-- <div class="col-xs-12 col-md-4">
                <div class="form-field select">
                  <div class="select-field">
                    <select name="dia" v-model="form.dia" id="dia">
                      <option disabled value="">Seleccione...</option>
                      <option value="1">Lunes</option>
                      <option value="2">Martes</option>
                      <option value="3">Miércoles</option>
                      <option value="4">Jueves</option>
                      <option value="5">Viernes</option>
                      <option value="6">Sábado</option>
                      <option value="7">Domingo</option>
                    </select>
                    <label for="dia">Día*</label>
                    <span
                      v-if="errores.dia"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.dia[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div> -->
              <div class="col-xs-12 col-md-4">
                <div class="form-field select2">
                  <div class="select2-field">
                    <v-select
                      placeholder="Seleccione..."
                      :options="recaudadores"
                      id="recaudador"
                      name="recaudador"
                      @input="inputRecaudador"
                      v-model="selectedRecaudador"
                      @search="searchRecaudadores"
                      label="descripcion"
                    ></v-select>
                    <label for="recaudador">Recaudador*</label>
                    <span
                      v-if="errores.recaudador_id"
                      class="helper-text text-danger"
                      slot="helper"
                    >
                      <strong>{{ errores.recaudador_id[0] }}</strong>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card__title">
            <h5>Geocercas</h5>
          </div>
          <div class="card__content">
            <geocercas
              v-model="form.geocercas"
              :clientes="form.clientes"
            ></geocercas>
          </div>
        </div>
        <div class="card">
          <div class="card__title">
            <h5>Vendedores</h5>
          </div>
          <div class="card__content">
            <vendedores-ruta v-model="form.vendedores"></vendedores-ruta>
          </div>
        </div>
      </div>
      <div class="layout__main-buttons">
        <div class="card">
          <div class="card__content">
            <button
              type="button"
              @click="guardar"
              class="btn-success btn--bigger"
              v-show="
                (estado === 'N' && puede_crear_ruta) ||
                (estado !== 'N' && puede_editar_ruta)
              "
            >
              <i class="fa fa-save"></i><span>Guardar</span>
            </button>
            <button
              v-show="puede_crear_ruta"
              @click="nueva"
              class="btn-light btn--text"
            >
              <i class="fa fa-plus"></i><span>Nueva</span>
            </button>
            <button
              v-show="puede_clonar_ruta && estado !== 'N'"
              @click="clonar"
              class="btn-secondary btn--text"
            >
              <i class="fa fa-clone"></i><span>Clonar</span>
            </button>
            <button
              type="button"
              @click="inactivar"
              v-show="estado !== 'N' && puede_eliminar_ruta"
              class="btn--text"
              :class="{
                'btn-danger': estado === 'A',
                'btn-success': estado === 'I',
              }"
            >
              <i class="fa fa-ban"></i
              ><span>{{ estado === "I" ? "Re-activar" : "Inactivar" }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <modal
      name="listaRutas"
      height="auto"
      width="65%"
      scrollable
      resizable
      adaptive
      reset
    >
      <lista-rutas
        @seleccionar="seleccionarRuta"
        ref="listaRutas"
        @cerrar="cerrarListaRutas"
      ></lista-rutas>
    </modal>
  </div>
</template>

<script>
import Geocercas from "./Geocercas.vue";
import ListaRutas from "./ListaRutas.vue";
import VendedoresRuta from "./VendedoresRuta.vue";

export default {
  props: [
    'bodegas',
    "puede_crear_ruta",
    "puede_editar_ruta",
    "puede_eliminar_ruta",
    "puede_consultar_rutas",
    "puede_clonar_ruta",
    "clon",
  ],
  components: {
    Geocercas,
    ListaRutas,
    VendedoresRuta,
  },
  mounted: function () {
    if (this.clon != null) {
      this.cargarDatosRuta(this.clon, true);
    }
  },
  data: function () {
    return {
      form: {
        bodega_id: '',
        codigo: "",
        nombre: "",
        direcciones: "",
        recaudador_id: "",
        dia: "",
        clientes: [],
        vendedores: [],
        geocercas: [],
        _method: undefined,
      },
      errores: {},
      selectedRecaudador: null,
      recaudadores: [],
      estado: "N",
      selectedBodega: null
    };
  },
  methods: {
    inputBodega: function () {
      if (this.selectedBodega != null) 
        this.form.bodega_id = this.selectedBodega.id;
      else 
        this.form.bodega_id = '';
    },

    cargarDatosRuta: function (data, clon = false) {
      if (!clon) {
        this.id = data.id;
        this.estado = data.estado;
        this.form.codigo = data.codigo;
      }
      this.form.bodega_id = data.bodega_id;
      for (let i = 0; i < this.bodegas.length; i++) {
        if (this.bodegas[i].id == this.form.bodega_id) {
          this.selectedBodega = this.bodegas[i];
          break;
        }
      }
      this.form.nombre = data.nombre;
      this.form.direcciones = data.direcciones;
      this.form.dia = data.dia;
      this.selectedRecaudador = data.recaudador;
      this.form.recaudador_id = data.recaudador_id;
      this.form.clientes.splice(0, this.form.clientes.length);
      for (let i = 0; i < data.clientes.length; i++)
        this.form.clientes.push({
          id: data.clientes[i].id,
          nombre: data.clientes[i].descripcion,
          direccion: data.clientes[i].direccion,
          latitud: data.clientes[i].coordenadas_cliente != null?data.clientes[i].coordenadas_cliente["coordinates"][1]:'',
          longitud: data.clientes[i].coordenadas_cliente != null?data.clientes[i].coordenadas_cliente["coordinates"][0]:'',
        });
      this.form.vendedores.splice(0, this.form.vendedores.length);
      for (let i = 0; i < data.vendedores.length; i++)
        this.form.vendedores.push({
          id: data.vendedores[i].id,
          descripcion: data.vendedores[i].descripcion,
          direccion: data.vendedores[i].direccion,
          telefonos: data.vendedores[i].telefonos,
          correos: data.vendedores[i].correos,
        });
      this.form.geocercas.splice(0, this.form.geocercas.length);
      for (let i = 0; i < data.geocercas.length; i++) {
        this.form.geocercas.push({
          descripcion: data.geocercas[i].descripcion,
          radio: data.geocercas[i].radio,
          latitud: data.geocercas[i].coordenadas_geocerca.coordinates[1],
          longitud: data.geocercas[i].coordenadas_geocerca.coordinates[0],
          latLng: [
            data.geocercas[i].coordenadas_geocerca.coordinates[1],
            data.geocercas[i].coordenadas_geocerca.coordinates[0],
          ],
        });
      }
    },
    clonar: function () {
      window.open(url + "/logistica/rutas/" + this.id + "/clonar", "_blank");
    },
    seleccionarRuta: function (ruta) {
      axios
        .get(url + "/logistica/rutas/" + ruta.id)
        .then(({ data }) => {
          this.cargarDatosRuta(data);
          this.$modal.hide("listaRutas");
        })
        .catch(() => {
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    consultar: function () {
      this.$modal.show("listaRutas");
    },
    cerrarListaRutas: function () {
      this.$modal.hide("listaRutas");
    },
    searchRecaudadores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.recaudadores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open(
        "GET",
        url + "/search/usuarios?tipo=R&search=" + search,
        true
      );
      xmlhttp.send();
    },
    inactivar: function () {
      swal({
        title:
          "¿Deseas " +
          (this.estado !== "I" ? "Inactivar" : "Re-activar") +
          " la ruta?",
        text:
          "Se realizará la " +
          (this.estado !== "I" ? "inactivación" : "re-activación") +
          " de la ruta",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          axios
            .post(url + "/logistica/rutas/" + this.id, {
              _method: "PUT",
            })
            .then(({ data }) => {
              this.form.estado = data.estado;
              swal(
                "La ruta fue " +
                  (data.estado === "A" ? "activada" : "inactivada") +
                  " exitósamente.",
                "Realizado",
                "success"
              );
            })
            .catch(() => {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    guardar: function () {
      this.errores = {};
      swal({
        title: "¿Deseas guardar los cambios?",
        text: "Se almacenará la información de la ruta",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          let urlRequest = url + "/logistica/rutas";
          if (this.estado !== "N") {
            urlRequest += "/" + this.id;
            this.form._method = "PUT";
          } else this.form._method = undefined;
          axios
            .post(urlRequest, this.form)
            .then(({ data }) => {
              swal(
                "La ruta ha sido almacenada exitósamente.",
                "Aviso",
                "success"
              );
              this.id = data.id;
              this.estado = data.estado;
            })
            .catch(({ response }) => {
              let status = response.status;
              if (status == 422) {
                this.errores = response.data.errors;
                swal("Hay errores en el formulario.", "Aviso", "warning");
              } else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    nueva: function () {
      swal({
        title: "¿Deseas crear una nueva ruta?",
        text: "Se reiniciará el formulario",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          this.errores = {};
          this.form.codigo = "";
          this.form.nombre = "";
          this.form.direcciones = "";
          this.form.dia = "";
          this.form.geocercas.splice(0, this.form.geocercas.length);
          this.form.vendedores.splice(0, this.form.vendedores.length);
          this.form.clientes.splice(0, this.form.clientes.length);
          this.form.recaudador_id = "";
          this.selectedRecaudador = null;
          this.estado = "N";
        }
      });
    },
    inputRecaudador: function () {
      if (this.selectedRecaudador != null)
        this.form.recaudador_id = this.selectedRecaudador.id;
      else this.form.recaudador_id = "";
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/logistica/rutas/Ruta.vue